import { AvcAuthErrorReason } from './avc-connect-modal.types';

const AVC_CONNECT_MODAL_COPY = {
  intro: {
    title: 'Connect Amazon Vendor Central',
    description:
      "You'll be redirected to Amazon to grant Vizit read-only access. We'll sync your product catalog and sales data so we can calculate revenue potential for every PDP.",
    readOnly: 'Read-only access',
    soc2: 'SOC2 Type II',
    cancel: 'Cancel',
    submit: 'Continue with Amazon',
  },
  error: {
    title: "We couldn't connect Amazon Vendor Central",
    cancel: 'Close',
    retry: 'Try again',
    reasons: {
      [AvcAuthErrorReason.UserDenied]: 'You declined access on Amazon. Approve read-only access to continue.',
      [AvcAuthErrorReason.StateInvalid]: 'The connection link is invalid. Please start over.',
      [AvcAuthErrorReason.StateExpired]: 'The connection link expired before we could finish. Please try again.',
      [AvcAuthErrorReason.CodeExchangeFailed]:
        "We couldn't exchange the authorization with Amazon. Please try again in a moment.",
      [AvcAuthErrorReason.InternalError]: 'Something went wrong on our side. Please try again in a moment.',
      [AvcAuthErrorReason.OrgAdminRequired]:
        'Only organization admins can connect Amazon Vendor Central. Ask an admin on your team to set it up.',
      [AvcAuthErrorReason.RetailerRegionUnsupported]:
        'Vendor Central is only supported for Amazon US and Amazon UK today. Your organization is set to a different region.',
      [AvcAuthErrorReason.Unknown]: 'Something went wrong while connecting. Please try again.',
    } satisfies Record<AvcAuthErrorReason, string>,
  },
} as const;

export { AVC_CONNECT_MODAL_COPY };
